import { useMemo } from 'react';
import * as Sentry from '@sentry/react';

export const useSentryTransaction = (name: string, op: string) => {
  return useMemo(() => {
    return Sentry.startTransaction({ name, op });
  }, [name, op]);
};
